export const environment = {
  useMocks: false,
  enableConsoleLog: true,
  apollo: {
    apiUrl: 'https://preview-partner.klobal.cz/graphql',
    subscriptionsUrl: 'wss://preview-partner.klobal.cz/subscriptions',
  },
  rest: {
    apiV2Url: 'https://preview-partner.klobal.cz/api/v2',
  },
  sentry: {
    allow: true,
    dsn: 'https://58a4f7e5c57266679f977a77d3e128b5@o4506434096201728.ingest.us.sentry.io/4506828864356352',
  },
  routerTracing: false,
  environment: 'preview',
  appVersion: 'dev-ea3778f9f0678716d95463dc1d88e5e5f3f7723c',
};
